import { constants } from "@/constants";
import { Trans } from "react-i18next";
import { Outlet } from "react-router-dom";

import Logo from "@/components/atoms/Logo";

/**
 * This Layout is used for pages that should not have a sidebar eg Payment success or error page
 */
const StateLayout = () => {
  return (
    <div className={"flex h-screen flex-col gap-4"}>
      <Outlet />

      <div className={"flex flex-col items-center gap-2 pb-10"}>
        <Logo className={"size-5"} />
        <p className={"text-xs text-quinary"}>
          <Trans
            i18nKey="needHelp"
            values={{ email: constants.supportMail }}
            components={{ a: <a href={"mailto:" + constants.supportMail} className={"text-link underline"} /> }}
          />
        </p>
      </div>
    </div>
  );
};

export default StateLayout;
